module.exports = __webpack_public_path__ + "e97202b981d72b88553f3981620dfadd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo-moka-full.png
// module id = 3161
// module chunks = 0